import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DialogService } from 'src/app/services/dialogs.service';
import { InputsBindingsModel } from 'src/app/common/Models/Dialog/inputs-binding.model';
import { ValueAndDisplay } from 'src/app/common/UI-Components/helperClasses/value-and-display.class';

@Injectable({
  providedIn: 'root'
})
export class LayersUnsavedChangesService {
  public hasUnsavedChanges = false;
  private currentSiteName = '';
  private saveAndLeaveHandler: (() => Observable<boolean>) | null = null;

  constructor(private readonly dialogService: DialogService) {}

  public setCurrentSiteName(siteName: string | null | undefined): void {
    this.currentSiteName = (siteName || '').trim();
  }

  public setSaveAndLeaveHandler(handler: (() => Observable<boolean>) | null): void {
    this.saveAndLeaveHandler = handler;
  }

  public confirmLeaveIfDirty(): Observable<boolean> {
    if (!this.hasUnsavedChanges) {
      return of(true);
    }

    return new Observable(observer => {
      const siteName = this.currentSiteName || 'Site';
      const inputsBinding: InputsBindingsModel = new Map<string, any>([
        ['type', 'warning'],
        ['title', 'Unsaved Changes'],
        ['message', `Site "${siteName}" has unsaved changes.\nDo you want to save them before continuing?`],
        ['buttonsInfo', [
          new ValueAndDisplay('keepEditing', 'Keep Editing'),
          new ValueAndDisplay('discardAndLeave', 'Discard'),
          new ValueAndDisplay('saveAndLeave', 'Save')
        ]]
      ]);

      const dialog = this.dialogService.createNotificationDialog(inputsBinding);
      dialog.onClose$().subscribe(data => {
        const action = data.userAction;

        if (action === 'keepEditing') {
          observer.next(false);
          observer.complete();
          return;
        }

        if (action === 'discardAndLeave') {
          this.hasUnsavedChanges = false;
          observer.next(true);
          observer.complete();
          return;
        }

        if (action === 'saveAndLeave') {
          if (!this.saveAndLeaveHandler) {
            observer.next(false);
            observer.complete();
            return;
          }

          this.saveAndLeaveHandler().subscribe((saved) => {
            if (saved) {
              this.hasUnsavedChanges = false;
            }
            observer.next(saved);
            observer.complete();
          });
          return;
        }

        observer.next(false);
        observer.complete();
      });
    });
  }
}
